import React, { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  getRecentsearch,
  getRecentProducts,
  getRecentCategories,
  addCart,
  getCart,
} from "../../utils/storage";
import StarRatings from "react-star-ratings";
import { ToastContainer, toast } from "react-toastify";
import BreadCrumb from "../../components/breadcrumb/breadcrumb";
import { cartAdd, cartAdding } from "../../actions/cart";

const ViewAll = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [value, setValue] = useState({
    check: false,
  });

  const [check1, setCheck1] = useState(false);
  const _addToCart = (item) => {
    // console.log(item);

    const image = [item.image];
    const item1 = {
      enableSale: item.enableSale,
      id: item.id,
      images: image,
      name: item.name,
      price: item.price,
      reviewCount: item.reviewCount,
      reviews: item.reviews,
      saleDiscount: item.saleDiscount,
      slug: item.slug,
    };

    var getItems = [];
    var arr = getCart();
    if (arr) {
      arr.forEach((x) => {
        if (item["id"] !== x.item.id) {
          getItems.push(x);
        }
      });
    }
    const data = {
      item: item1,
      quantity: 1,
    };
    getItems.push(data);

    console.log(data);
    addCart(getItems);
  };
  return (
    <Fragment>
      <ToastContainer
        enableMultiContainer
        containerId={"B"}
        position={toast.POSITION.TOP_RIGHT}
      />
      <BreadCrumb title={`Recently Viewed`} />
      <div className="customer-also-view px-sm-2">
        <div
          className="container py-3"
          id="categorie-Pets-slider"
          style={{ backgroundColor: "#f4f4f5" }}
        >
          <h2 className="cust-viwed">Recently Viewed </h2>
          <span className="ml-3 d-block">
            take a second look at what you've been up to on Sundial!
          </span>
          <div className="row">
            {getRecentProducts().map((x, i) => (
              <div className="col-md-3 py-1 col-6 mt-3">
                <div className="categoriesslider">
                  <div className="product-cards d-flex justify-between flex-column">
                    <Link
                      to={`/product/${x["slug"]}`}
                      style={{ color: "inherit", display: "block" }}
                    >
                      <div className="product-cards-img">
                        <div
                          style={{
                            backgroundImage: `url(${x["image"]}`,
                            backgroundSize: "contain",
                            height: "100%",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                          }}
                        ></div>
                      </div>
                    </Link>
                    <div className="product-cards-content">
                      <div className="product-cards-txt">
                        <Link
                          to={`/product/${x["slug"]}`}
                          style={{ color: "inherit", display: "block" }}
                        >
                          <span className="name-dots">{x.name}</span>
                          <div className="product-cards-price">
                            {x.enableSale ? <span>$748</span> : null}

                            {x.enableSale ? (
                              <span>
                                <del>{(x.price * x.saleDiscount) / 100}</del>
                              </span>
                            ) : (
                              <span>$748</span>
                            )}
                          </div>
                          <div className="product-cards-rating">
                            <ul className="product-rating">
                              <StarRatings
                                rating={x.reviews}
                                starDimension="20px"
                                starSpacing="2px"
                                starRatedColor="gold"
                              />
                              <span>{x.reviewCount}</span>
                            </ul>
                            <span>
                              <b>Free Shipping</b>
                              <b></b>
                            </span>
                          </div>
                        </Link>
                        <div className="add-cart text-center">
                          <button
                            className="add-myCart recent-cart"
                            onClick={() => {
                              _addToCart(x);
                            }}
                          >
                            <span>
                              <i className="fas fa-cart-plus" />
                              &nbsp; Add
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="row">
            <div className="col-sm-6">
              <div className="recent-views-heading">
                <h2>Your Searches</h2>
              </div>
              {value.check ? (
                <>
                  {" "}
                  <div className="row">
                    {getRecentsearch().map((x, i) => (
                      <div className="col-md-6">
                        <div className="sub-categories">
                          <Link
                            to={`/search/${x}`}
                            className="sub-category mx-0 p-recent"
                          >
                            <span className="sub-cat-name">
                              {x.substring(0, 30)}...
                            </span>
                          </Link>
                        </div>
                      </div>
                    ))}
                  </div>
                  <span
                    className="ml-3 viewRecentSearch"
                    onClick={() => setValue({ ...value, check: false })}
                  >
                    Show Less
                  </span>
                </>
              ) : (
                <>
                  <div className="row">
                    {getRecentsearch()
                      .slice(0, 4)
                      .map((x, i) => {
                        return i === 0 || i === 1 ? (
                          <div className="col-md-6">
                            <div className="sub-categories">
                              <Link
                                to={`/search/${x}`}
                                className="sub-category mx-0 p-recent"
                              >
                                <span className="sub-cat-name">
                                  {x.substring(0, 30)}...
                                  {/* Sofas &amp; Loveseats */}
                                </span>
                              </Link>
                            </div>
                          </div>
                        ) : (
                          <div className="col-md-6">
                            <div className="sub-categories box-bluring">
                              <Link
                                to={`/search/${x}`}
                                className="sub-category half-box mx-0 p-recent"
                              >
                                <span className="sub-cat-name">
                                  {x.substring(0, 30)}...
                                  {/* Sofas &amp; Loveseats */}
                                </span>
                              </Link>
                              {/*     <a
                      className="sub-category half-box mx-0 p-recent"
                      href="/category/products/sofas-&amp;-loveseats"
                    >
                      <span className="sub-cat-name">{x.substring(0, 30)}...</span>
                    </a> */}
                            </div>
                          </div>
                        );
                      })}
                  </div>
                  <span
                    className="ml-3 viewRecentSearch"
                    onClick={() => setValue({ ...value, check: true })}
                  >
                    {" "}
                    View All Recent Searches
                  </span>
                </>
              )}
            </div>
            <div className="col-sm-6">
              <div className="recent-views-heading">
                <h2>Categories You Visited</h2>
              </div>

              {check1 ? (
                <>
                  {" "}
                  <div className="row">
                    {getRecentCategories().map((x, i) => (
                      <div className="col-md-6">
                        <div className="sub-categories">
                          <Link
                            to={`/products/${x.slug}`}
                            className="sub-category mx-0"
                          >
                            <span className="sub-cat-img">
                              <img
                                src={x.image}
                                alt=""
                                style={{ width: "40px", height: "40px" }}
                              />
                            </span>
                            <span className="sub-cat-name">{x.name}</span>
                          </Link>
                        </div>
                      </div>
                    ))}
                  </div>
                  <span
                    className="ml-3 viewRecentSearch"
                    onClick={() => setCheck1(false)}
                  >
                    {" "}
                    Show Less
                  </span>
                </>
              ) : (
                <>
                  {" "}
                  <div className="row">
                    {getRecentCategories()
                      .slice(0, 4)
                      .map((x, i) => {
                        return i === 0 || i === 1 ? (
                          <div className="col-md-6">
                            <div className="sub-categories">
                              <Link
                                to={`/products/${x.slug}`}
                                className="sub-category mx-0"
                              >
                                <span className="sub-cat-img">
                                  <img
                                    src={x.image}
                                    alt=""
                                    style={{ width: "40px", height: "40px" }}
                                  />
                                </span>
                                <span className="sub-cat-name">{x.name}</span>
                              </Link>
                              {/*       <a
                      className="sub-category mx-0"
                      href="/category/products/sofas-&amp;-loveseats"
                    >
                      <span className="sub-cat-img">
                        <img
                          src={x.image}
                          alt=""
                          style={{ width: "40px", height: "40px" }}
                        />
                      </span>
                      <span className="sub-cat-name">{x.name}</span>
                    </a> */}
                            </div>
                          </div>
                        ) : (
                          <div className="col-md-6">
                            <div className="sub-categories box-bluring">
                              <Link
                                to={`/products/${x.slug}`}
                                className="sub-category half-box mx-0 p-recent"
                              >
                                <span className="sub-cat-img">
                                  <img
                                    src={x.image}
                                    alt=""
                                    style={{ width: "40px", height: "40px" }}
                                  />
                                </span>
                                <span className="sub-cat-name">{x.name}</span>
                              </Link>
                              {/*  <a
                      className="sub-category half-box mx-0 p-recent"
                      href="/category/products/sofas-&amp;-loveseats"
                    >
                      <span className="sub-cat-img">
                        <img
                          src={x.image}
                          alt=""
                          style={{ width: "40px", height: "40px" }}
                        />
                      </span>
              <span className="sub-cat-name">{x.name}</span>
                    </a> */}
                            </div>
                          </div>
                        );
                      })}
                  </div>
                  <span
                    className="ml-3 viewRecentSearch"
                    onClick={() => setCheck1(true)}
                  >
                    {" "}
                    View All Recent Categories
                  </span>
                </>
              )}
            </div>
          </div>
        </div>
        {/* END BEFORE FOOTER AREA */}
        {/* footer */}
      </div>
    </Fragment>
  );
};

export default ViewAll;
